import { Link } from 'react-router-dom';
import { Shield } from 'lucide-react';

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="w-full border-t border-[#E2E8F0] bg-white mt-auto">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 flex items-center justify-between">
        <div className="flex items-center gap-4">
          <img src="/icon-nav.png" alt="Local Luc" className="h-8 w-8 rounded-lg object-cover opacity-80" />
          <span className="text-xs text-[#64748B]">Local Luc &middot; Rank Higher. Grow Local.</span>
        </div>
        <div className="flex items-center gap-4 text-xs text-[#64748B]">
          <Link to="/privacy" className="hover:text-[#0F2951] transition-colors">Privacy</Link>
          <Link to="/terms" className="hover:text-[#0F2951] transition-colors">Terms</Link>
          <Link to="/admin" data-testid="footer-admin-link" className="flex items-center gap-1 hover:text-[#0268C4] transition-colors">
            <Shield className="w-3 h-3" /> Admin
          </Link>
        </div>
      </div>
    </footer>
  );
}
